import type { FC, ReactElement } from 'react';

import { HelpText } from '../../../../services/helpTranslations/reactBindings/HelpText';
import { GameButton } from '../../../game/gameButton/gameButton';
import { Icons } from '../../../icons/iconNames';
import { useHelpContext } from '../../hooks/useHelpContext';
import { HelpComponentWrapper } from '../../utils/HelpComponentWrapper';

import styles from './HelpCrash.module.css';

export const HelpChapterCrashAutoplay: FC = () => {
  const { isInfiniteAutoPlayVisible } = useHelpContext().autoPlay;

  return (
    <div>
      <p>
        <HelpText
          tk={`autoplay.${isInfiniteAutoPlayVisible ? 'autoplayFeatureInfinite' : 'autoplayFeature'}`}
          markdown
        />
      </p>
      <HelpComponentWrapper>
        {isInfiniteAutoPlayVisible ? <InfiAutoPlay checked={false} /> : <GameButton icon={Icons.Autoplay} border />}
      </HelpComponentWrapper>
      <p>
        <HelpText tk={`autoplay.${isInfiniteAutoPlayVisible ? 'infiniteAutoplayBet' : 'autoplayWindow'}`} />
      </p>
      {!isInfiniteAutoPlayVisible ? (
        <p>
          <HelpText tk="autoplay.autoplayStart" />
        </p>
      ) : null}
      <HelpComponentWrapper>
        {isInfiniteAutoPlayVisible ? (
          <InfiAutoPlay checked={true} />
        ) : (
          <GameButton icon={Icons.Autoplay} border badge={1} />
        )}
      </HelpComponentWrapper>
      <p>
        <HelpText tk="autoplay.autoplayCashout" />
      </p>
      <p>
        <HelpText tk={`autoplay.${isInfiniteAutoPlayVisible ? 'autoplayAutoStop' : 'autoplayStop'}`} markdown />
      </p>
      <ol>
        <li>
          <HelpText tk={`autoplay.${isInfiniteAutoPlayVisible ? 'stopCancel' : 'stopZero'}`} />
        </li>
        <li>
          <HelpText tk={`autoplay.${isInfiniteAutoPlayVisible ? 'stopExit' : 'stopBalance'}`} />
        </li>
        {isInfiniteAutoPlayVisible ? (
          <li>
            <HelpText tk="autoplay.stopLinkedBetBalance" />
          </li>
        ) : null}
      </ol>
      {!isInfiniteAutoPlayVisible ? (
        <p>
          <HelpText tk="autoplay.stopChanges" />
        </p>
      ) : null}
    </div>
  );
};

const InfiAutoPlay = ({ checked }: { checked: boolean }): ReactElement => {
  return (
    <div data-testid="toggle" className={styles.toggle}>
      <input className={styles.toggle__input} type="checkbox" checked={checked} id="infiAutoplay" />
      <label htmlFor="infiAutoplay" className={styles.toggle__track}>
        <span className={styles.toggle__handle_crash} />
      </label>
    </div>
  );
};
